<template>
	<router-view :key="viewKey"></router-view>
</template>

<script>
	import {
		langState
	} from '../../../language'
	export default {
		//props:['MenuList'],
		computed: {
			//路由出口 key：路径 + 语言版本，切换语言时重建页面
			viewKey() {
				return this.$route.fullPath + '|' + langState.version
			}
		},
		data() {
			return {}
			}
			}
</script>

<style>
</style>
